import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";
import AdminRoutes from '@/routers/adminRouter';
import SchoolStaffRouter from '@/routers/schoolStaffRouter';
import StudentRouter from '@/routers/studentRouter';
import AuthRouter from '@/routers/authRouter';

const routes = [


  // Auth LAYOUT
  {
    path: '/', 
    redirect:'login',
    name: 'Auth Layout',
    component: AuthLayout, 
    children: AuthRouter
  },

  // ADMIN
  {
    path: '/',
    name: 'Admin Layout',
    component: DashboardLayout,
    children: AdminRoutes
  },

  // School Staff Router
  {
    path: '/',
    name: 'School Staff Router',
    component: DashboardLayout,
    children: SchoolStaffRouter
  },

  // Student Router
  {
    path: '/',
    name: 'Student Router',
    component: DashboardLayout,
    children: StudentRouter
  },

  // NOT FOUND
  {
    path: '*',
    name: 'Not Found',
    component: () => import('@/views/NotFound.vue')
  }
]

export default routes